import { css } from 'styled-components';
import { toInteger } from 'lodash';
import { breakpoints, media, customMinResponsive } from './MediaQueries';

const getImageUrl = (src, breakpoint, aspectRatio = 16 / 9) => `url(${src}=w${breakpoint}-h${toInteger(breakpoint / aspectRatio)})`;

export const backgroundImage = (src, aspectRatio) => css`
	background-image: ${getImageUrl(src, breakpoints.xmin, aspectRatio)};
	${media.min.xmin(css`
		background-image: ${getImageUrl(src, breakpoints.min, aspectRatio)};
	`)};
	${media.min.min(css`
		background-image: ${getImageUrl(src, breakpoints.small, aspectRatio)};
	`)};
	${media.min.small(css`
		background-image: ${getImageUrl(src, breakpoints.medium, aspectRatio)};
	`)};
	${media.min.medium(css`
		background-image: ${getImageUrl(src, breakpoints.large, aspectRatio)};
	`)};
	${media.min.large(css`
		background-image: ${getImageUrl(src, breakpoints.max, aspectRatio)};
	`)};
	${customMinResponsive(
		2000,
		css`
			background-image: ${getImageUrl(src, 2540, aspectRatio)};
		`
	)}
`;
